import React, { useState } from "react";
import { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { HiSearch } from "react-icons/hi";
import { useFormik } from "formik";
import { AddKitSchema } from "../../validations/validation";
import {
  deleteData,
  fetchBlob,
  fetchData,
  SubmitData,
  updateJsonData,
} from "../../services/apiService";
import useAlertUtils from "../../utils/common.utils";
import {
  decryptedData,
  encryptData,
  makeEncryptionData,
} from "../../services/encryptionDecription.service";
import { MdDeleteOutline } from "react-icons/md";

function Dashboard() {
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const limit = 10;

  const [input, setInput] = useState("");
  const [message, setMessage] = useState();

  const { alertSuccess, alertError } = useAlertUtils();
  const [resultData, setResultData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const data = {
    kitId: "",
    dob_day: 14,
    dob_year: 1974,
    dob_month: 6,
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    formik.setValues({ ...data });
    setMessage();

    setOpen(true);
  };
  const handleClose = () => {
    setMessage();
    setOpen(false);
  };

  const setForm = () => {
    formik.setValues({ ...data });
  };

  const formik = useFormik({
    initialValues: data,
    validationSchema: AddKitSchema,
    onSubmit: async (values) => {
      try {
        const dob =
          values.dob_year + "-" + values.dob_month + "-" + values.dob_day;
        values.dob = dob;
        delete values.dob_year;
        delete values.dob_month;
        delete values.dob_day;

        const encryptedData = makeEncryptionData(values);
        const response = await SubmitData(
          "/api/zrt/kit/retrieve",
          encryptedData
        );

        if (response?.success) {
          resultData.push(response?.data);
          setResultData(resultData);
          setOpen(false);
        } else {
          setForm();
          setMessage(response?.message);
        }
      } catch (error) {
        setMessage("An error occurred while submitting the form.");
      }
    },
  });

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setCurrentPage(selectedPage);
    resulFunc();
  };

  const resulFunc = async () => {
    try {
      setIsLoading(true);
      let results = await fetchData(
        "/api/zrt/kits?page=" +
          currentPage +
          "&limit=" +
          limit +
          "&search=" +
          input
      );

      let kits = results?.data?.data || [];
      let totalPages = results?.data?.totalPages;

      const kitsNeedingRefresh = kits.filter(
        (kit) => kit.Identity !== "Verified"
      );

      if (kitsNeedingRefresh.length > 0) {
        await Promise.all(
          kitsNeedingRefresh.map((kit) =>
            updateJsonData(`/api/zrt/refreshKit/${kit.kitId}`, {})
          )
        );

        results = await fetchData(
          "/api/zrt/kits?page=" +
            currentPage +
            "&limit=" +
            limit +
            "&search=" +
            input
        );

        kits = results?.data?.data || [];
        totalPages = results?.data?.totalPages;
      }

      setResultData(kits);
      setPageCount(totalPages);
    } catch (error) {
      console.error("Error during fetch or refresh:", error);
      alertError("Failed to fetch results. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    resulFunc();
  }, []);

  const downloadResult = async (kitId) => {
    try {
      let pdf = await fetchBlob("/api/zrt/result/pdf/" + encryptData(kitId));
      const blob = new Blob([pdf.data], { type: "application/pdf" });

      const url = URL.createObjectURL(blob);

      let alink = document.createElement("a");
      alink.href = url;
      alink.download = kitId + "-results.pdf";
      alink.click();
    } catch (error) {
      alertError("Failed to download the result. Please try again.");
    }
  };

  function searchFunc(val) {
    resulFunc();
  }

  const deleteKit = async (kitId) => {
    try {
      const response = await deleteData("/api/zrt/kits/" + kitId);
      console.log(response);
      if (response?.status === 200) {
        alertSuccess("Kit deleted successfully");
        resulFunc();
      } else {
        alertError("Failed to delete the kit. Please try again.");
      }
    } catch (error) {
      alertError("Failed to delete the kit. Please try again.");
    }
  };

  return (
    <>
      <Header></Header>
      <div className="main_content">
        <div className="container">
          <div className="main_block">
            <div className="top_bar">
              <div className="left_part">
                <div className="main_title">My Results</div>
              </div>

              <div className="right_part">
                <div className="right_part_inner">
                  <div className="search_bar">
                    <div className="input-group">
                      <input
                        type="search"
                        value={input}
                        onInput={(e) => setInput(e.target.value)}
                        className="form-control"
                        placeholder="Search by KitId"
                        aria-label="Search"
                      />
                      <button className="btn search-btn" onClick={searchFunc}>
                        <HiSearch size={20} />
                      </button>
                    </div>
                  </div>

                  <button
                    className="btn btn-primary add_kit"
                    onClick={handleOpen}
                  >
                    add kit
                  </button>
                </div>
              </div>
            </div>

            <div class="bottom_bar">
              <div class="table_wrapper dashboard">
                <div class="table_inner">
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Kit</TableCell>

                          <TableCell align="right">Sample Received</TableCell>
                          <TableCell>Report Status</TableCell>
                          <TableCell>Report Identity</TableCell>
                          <TableCell align="right">Report Date</TableCell>
                          <TableCell align="right">Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!isLoading &&
                          resultData?.map((row) => (
                            <TableRow
                              key={resultData.kitId}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="right">
                                <span className="mob_head">Kit</span>
                                {row.kitId}
                              </TableCell>

                              <TableCell align="right">
                                {" "}
                                <span className="mob_head">
                                  Sample Received
                                </span>
                                {decryptedData(row.samplesReceived)}
                              </TableCell>
                              <TableCell align="right">
                                {" "}
                                <span className="mob_head">
                                  Report Status
                                </span>{" "}
                                {row.status}{" "}
                              </TableCell>

                              <TableCell align="right">
                                <span className="mob_head">
                                  Report Identity
                                </span>
                                {row.Identity}
                              </TableCell>

                              <TableCell align="right">
                                <span className="mob_head">Report Date</span>
                                {decryptedData(row.ReportDate)}
                              </TableCell>
                              <TableCell align="right">
                                {/* check if the results are ready for download  */}
                                <span className="mob_head">Action</span>
                                {row.status === "Ready" ? (
                                  <div className="icon_group">
                                    <Link
                                      className="action_link"
                                      to={
                                        "/app/report/" +
                                        btoa(encryptData(row.kitId))
                                      }
                                    >
                                      View Reports
                                    </Link>

                                    <Link
                                      className="action_link"
                                      onClick={() => downloadResult(row.kitId)}
                                    >
                                      Download
                                    </Link>
                                  </div>
                                ) : (
                                  // <div className="icon_group">
                                  //   <MdDeleteOutline
                                  //     style={{
                                  //       cursor: "pointer",
                                  //     }}
                                  //     onClick={() => deleteKit(row.kitId)}
                                  //     color="red"
                                  //     size={20}
                                  //   />
                                  // </div>

                                  <Link
                                    style={{
                                      color: "red",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => deleteKit(row.kitId)}
                                  >
                                    Delete Kit
                                  </Link>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}

                        {isLoading ? (
                          <TableCell colSpan={6}>
                            <div className="loading-state">
                              <div className="spinner"></div>
                              <p>Loading Kits ...</p>
                            </div>
                          </TableCell>
                        ) : (
                          ""
                        )}

                        {!isLoading && resultData?.length === 0 ? (
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell colSpan={6}>
                              <div className=" notice">
                                <div className="alert">
                                  <span className="alertText">
                                    No Records Found, add kit using the Add Kit
                                    button
                                  </span>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : (
                          ""
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        marginPagesDisplayed={2}
        containerClassName="pagination justify-content-center"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="modal_block add_kit">
            <div className="modal_header">
              <div className="modal_title_wrapper">
                <h2 className="modal_title">Add Kit</h2>
                <p className="modal_description">
                  Type in your Kit ID to add it to your account
                </p>
              </div>
            </div>
            <div className="modal_content">
              <div className="form_field_wrapper">
                <label>
                  Kit id<span className="req">*</span>
                  <Tooltip
                    title="Type in your Kit ID to add it to your account"
                    placement="top"
                  >
                    <HelpOutlineIcon />
                  </Tooltip>
                </label>
                <input
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.kitId || ""}
                  placeholder="Enter kit id"
                  className="form-control inp_text"
                  id="kitId"
                />
                <p className="error">
                  {formik.errors.kitId &&
                    formik.touched.kitId &&
                    formik.errors.kitId}
                </p>
              </div>
              {/* <div className="row">
                <label>
                  Date of birth<span className="req">*</span>
                  <Tooltip
                    title="Please verify your date of birth to verify your kit. We add this as another layer or security."
                    placement="top"
                  >
                    <HelpOutlineIcon />
                  </Tooltip>
                </label>
                <div className="col-sm-4 kit_item">
                  <div className="form_field_wrapper">
                    <label>
                      Month<span className="req">*</span>
                    </label>
                    <input
                      type="number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dob_month || ""}
                      placeholder="Enter month"
                      className="form-control inp_text"
                      id="dob_month"
                    />
                  </div>
                  <p className="error">
                    {formik.errors.dob_month &&
                      formik.touched.dob_month &&
                      formik.errors.dob_month}
                  </p>
                </div>
                <div className="col-sm-4 kit_item">
                  <div className="form_field_wrapper">
                    <label>
                      Day<span className="req">*</span>
                    </label>
                    <input
                      type="number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dob_day || ""}
                      placeholder="Enter day"
                      className="form-control inp_text"
                      id="dob_day"
                    />
                  </div>
                  <p className="error">
                    {formik.errors.dob_day &&
                      formik.touched.dob_day &&
                      formik.errors.dob_day}
                  </p>
                </div>
                <div className="col-sm-4 kit_item">
                  <div className="form_field_wrapper">
                    <label>
                      Year<span className="req">*</span>
                    </label>
                    <input
                      type="number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dob_year || ""}
                      placeholder="Enter year"
                      className="form-control inp_text"
                      id="dob_year"
                    />
                  </div>
                  <p className="error">
                    {formik.errors.dob_year &&
                      formik.touched.dob_year &&
                      formik.errors.dob_year}
                  </p>
                </div>
              </div> */}
              <div className="primary_btn">
                <button
                  className="btn btn-secondary cancel"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Add Kit
                </button>
              </div>
              <div className="primary_btn">
                {message ? <div className="alert">{message}</div> : ""}
              </div>
            </div>
          </div>
        </form>
      </Modal>

      <Footer></Footer>
    </>
  );
}

export default Dashboard;
